



















import { Component, Vue } from 'vue-property-decorator';
import { mdbBtn, mdbIcon, mdbTooltip } from '@folky-tools/mdbvue';
import AssociationBasicData from '@/components/associations/AssociationBasicData.vue';
import { usersService, associationsService, authorizationManagerService, notificationsService } from '@/services';
import { Association } from '@/models/associations/association';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { UserPermissionAction, UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';
import { GenericResult } from '@/models/common/results/generic-result';

@Component({
    components: {
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        AssociationBasicData,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class NewAssociationView extends Vue {
    private association: Association = new Association();
    private savingAssociation: boolean = false;

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.associations.newAssociationView.title');
        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Associations,
                scope: UserActionScopeType.New
            })
        );
    }

    private async createAssociation(): Promise<void> {
        this.savingAssociation = true;

        if ((this.$refs.associationBasicData as any).hasErrors()) {
            this.savingAssociation = false;
            return Promise.resolve();
        }

        try {
            const newAssociationResult: GenericResult = await associationsService.createAssociation(this.association);
            if (newAssociationResult.result) {
                notificationsService.showToastSuccessNotification('views.associations.newAssociationView.actions.save.success.notification');
                authorizationManagerService.addOrUpdatePermission(UserPermissionAction.Owner, UserEntityPermissionsType.Associations, newAssociationResult.id);

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasCreated,
                        entity: UserActionEntityType.Associations,
                        scope: UserActionScopeType.New,
                        entityId: newAssociationResult.id
                    })
                );

                this.$router.push('/associations');
                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingAssociation = false;
        }
    }

    private newAssociation(): void {
        this.association = new Association();
    }
}
